// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1aNKU","open":"Sidebar_open__2VOmW"};